module.exports = __webpack_public_path__ + "img/金燕e商贷（个人）.b377d4a8.png";